import { isLanguageSupported } from './languages';

/**
 * 检测浏览器语言偏好
 * @returns 支持的语言代码或null
 */
export const detectBrowserLanguage = (): string | null => {
  if (typeof navigator === 'undefined') {
    return null;
  }

  // 获取浏览器语言列表
  const browserLanguages = navigator.languages || [navigator.language];

  for (const browserLang of browserLanguages) {
    // 直接匹配完整语言代码
    if (isLanguageSupported(browserLang)) {
      return browserLang;
    }

    // 匹配语言的主要部分（如 zh-CN 匹配 zh）
    const mainLanguage = browserLang.split('-')[0];
    if (isLanguageSupported(mainLanguage)) {
      return mainLanguage;
    }

    // 特殊处理中文
    if (browserLang.startsWith('zh')) {
      // 检查是否为繁体中文
      if (
        browserLang.includes('TW') || 
        browserLang.includes('HK') || 
        browserLang.includes('MO') ||
        browserLang.includes('Hant')
      ) {
        return 'zh-TW';
      }
      // 默认为简体中文
      return 'zh-CN';
    }
  }

  return null;
};

/**
 * 获取浏览器的时区信息（用于国际化格式化）
 */
export const getBrowserTimezone = (): string => {
  if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.warn('Failed to detect timezone:', error);
    }
  }
  return 'UTC';
};

/**
 * 获取浏览器的数字格式偏好
 */
export const getBrowserNumberFormat = (): string => {
  if (typeof navigator !== 'undefined') {
    return navigator.language || 'en-US';
  }
  return 'en-US';
};